import React from 'react';
import Size1 from './Size1.jsx';
import Size2 from './Size2.jsx';
import YesOrNo from './YesOrNo.jsx';

export default function Step3(props) {
  const { sizes, getStandard, getLocation, getHasBootSize, setHasBootSize, getBootSize, setBootSize, getBootSize2, setBootSize2, isWomens, isSneaker } = props;

  let label = 'Do you own any Goodyear welted boots or dress shoes?';
  if (props.product.vendor.includes('Women')) {
    label = 'Do you own any leather boots?';

    if (props.product.tags.includes('goodyear-welt')) {
      label = 'Do you own any Goodyear welted leather boots?';
    }
  }

  let label2 = "Do you ever wear other sizes in Goodyear welted footwear?";
  if (props.product.vendor.includes('Women') && !props.product.tags.includes('goodyear-welt')) {
    label2 = "Do you ever wear other sizes in leather boots or shoes?";
  }

  return (
    <div className="form-body">
      <YesOrNo setValue={setHasBootSize} getValue={getHasBootSize} label={label} />
      {getHasBootSize && <Size1 location={getLocation} getSize={getBootSize} setSize={setBootSize} sizes={sizes[getStandard.code]} isWomens={isWomens} isSneaker={isSneaker} label="What size do you wear?" />}
      {getBootSize.us && <Size2 location={getLocation} getSize1={getBootSize} getSize2={getBootSize2} setSize2={setBootSize2} sizes={sizes[getStandard.code]} isWomens={isWomens} isSneaker={isSneaker} label={label2} />}
    </div>
  )
}